module.exports = __webpack_public_path__ + "img/dep_medicineandfirstaid.272cbb66.png";